export enum LocalStorageConstants {
	AWS_REGISTRATION_TOKEN = "aws_registration_token",
	FEEDBACK_COUNT = "feedback_count",
	IP_PROJECT_ID = "ip_project_id",
}
